import useGetProjectByIdOverview from '../api/queries/project/useGetProjectByIdOverview';
import { CustomerContact, ProjectByIdQuery } from '../gql/graphql';

const getPrimaryContactFromProjectCustomer = (
  project?: ProjectByIdQuery['projectById']
): CustomerContact | undefined => {
  return project?.customer?.contacts.find((c) => c.isPrimary);
};
export const useProjectPrimaryContact = (projectId: string) => {
  const { project } = useGetProjectByIdOverview(projectId);
  return getPrimaryContactFromProjectCustomer(project);
};
